/* assets/perf-late.js
   Carga tardía de 3P + micro-optimizaciones de LCP/TBT sin tocar visuales. */

(function () {
  // --- helpers ----------
  function loadScript(src, attrs = {}) {
    if (document.querySelector(`script[src^="${src.split('?')[0]}"]`)) return;
    const s = document.createElement('script');
    s.src = src;
    Object.entries(attrs).forEach(([k, v]) => v === true ? s.setAttribute(k, '') : s.setAttribute(k, v));
    (document.body || document.documentElement).appendChild(s);
  }
  function onIdle(fn, timeout = 4000) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout });
    else setTimeout(fn, timeout);
  }

  // --- Pop-Convert (TTL 3min en su CDN) -> cargar fuera del FCP/LCP ----
  function loadPopConvert() {
    // REEMPLAZA XXXX por tu unique_id real si lo usas en el HTML del proveedor
    loadScript('https://script.pop-convert.com/new-micro/production.pc.min.js?unique_id=XXXX', { async: true });
    loadScript('https://cdn.s3.pop-convert.com/pcjs.production.min.js?unique_id=XXXX', { async: true });
  }

  // --- Helixo (flags.png 1d): no es crítico para la primera pintura ----
  function loadHelixo() {
    // Si tu app inserta otros assets, déjalos para después de la interacción
    // (ejemplo: widgets de "frequently bought together", etc.)
    // Aquí solo preparamos hueco para futuras cargas si las hubiera.
  }

  // Dispara en reposo y también al primer gesto del usuario
  function lazyVendors() {
    loadPopConvert();
    loadHelixo();
  }
  onIdle(lazyVendors, 3000);
  ['click','scroll','keydown','mousemove','touchstart'].forEach(evt => {
    window.addEventListener(evt, function once() { lazyVendors(); window.removeEventListener(evt, once, { passive:true }); }, { passive:true, once:true });
  });

  // --- Mejora LCP de imágenes por si algún <img> llega sin decoding/fetchpriority
  document.addEventListener('DOMContentLoaded', () => {
    const imgs = document.querySelectorAll('img:not([decoding])');
    imgs.forEach((img, i) => {
      img.decoding = 'async';
      if (i === 0 && !img.hasAttribute('fetchpriority')) img.setAttribute('fetchpriority', 'high');
    });
  });
})();